module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "medal-wrapper"
  }, [_c('div', {
    staticClass: "medal-nav"
  }, _vm._l((_vm.medalTitleList), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "nav-list",
      class: {
        'active': index === _vm.curIndex
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.medalInfor(item.type, index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bottom-medal-list"
  }, [(_vm.allMedal.length) ? _c('div', {
    staticClass: "all-medal"
  }, [_c('div', {
    staticClass: "medal-content"
  }, _vm._l((_vm.allMedal), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "medal-list"
    }, [_c('div', {
      staticClass: "title-wrapper"
    }, [_c('h3', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.filterXSS(item.kind)))]), _vm._v(" "), _c('span', {
      staticClass: "line"
    })]), _vm._v(" "), _c('div', {
      staticClass: "medal-type"
    }, [_c('ul', _vm._l((item.data), function(medal, index) {
      return _c('li', {
        key: index,
        staticClass: "clearfix"
      }, [(medal.type) ? _c('p', {
        staticClass: "desctibe"
      }, [(medal.type === 'Gold') ? _c('img', {
        attrs: {
          "src": require("../images/personal_center/medal_03.png")
        }
      }) : _vm._e(), _vm._v(" "), (medal.type === 'Silver') ? _c('img', {
        attrs: {
          "src": require("../images/personal_center/medal_02.png")
        }
      }) : _vm._e(), _vm._v(" "), (medal.type === 'Copper') ? _c('img', {
        attrs: {
          "src": require("../images/personal_center/medal_01.png")
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        class: ['desc-text', {
          'sliver-text': medal.type === 'Sliver'
        }, {
          'copper-text': medal.type === 'Copper'
        }]
      }, [_vm._v(_vm._s(medal.type_text))])]) : _vm._e(), _vm._v(" "), _c('p', {
        staticClass: "condition"
      }, [_vm._v(_vm._s(_vm.filterXSS(medal.desc)))]), _vm._v(" "), _c('p', {
        staticClass: "gain-count"
      }, [_vm._v(_vm._s(_vm.filterXSS(medal.status)))])])
    }), 0)])])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.allMedal.length && !_vm.isMedalLoading) ? _c('div', {
    staticClass: "no-medal"
  }, [_c('img', {
    attrs: {
      "src": require("../images/developer/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无获奖记录！")])]) : _vm._e(), _vm._v(" "), _c('loading', {
    staticStyle: {
      "padding": "100px 0"
    },
    attrs: {
      "ifLoadingStart": _vm.isMedalLoading
    }
  }), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-a17ec3aa!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/medal.vue
// module id = nKlr
// module chunks = 15